export default {
  middleware_url: "https://urbantz.livraisons.pro",
  cake_url: "https://urbantz.cake.livraisons.pro",
  isWavesoftEnabled: false,
  isUrbantzEnabled: true,
  showLockBillingButton: true,
  useMapPage: true,
  instancePrefix: "25",
  googleMap: {
    api: "AIzaSyCPQ-mWkw-QJAiIsfx23XnY-5-uWhw3vsE",
  },
};
